import { Injectable, inject, signal } from '@angular/core';
import { finalize, tap } from 'rxjs';

import { FavoriteApiService } from '@bookly-user/rooms/services/favorite-api.service';

@Injectable({
  providedIn: 'root',
})
export class FavoriteService {
  readonly #favoriteService = inject(FavoriteApiService);

  readonly #isLoading = signal(false);
  readonly #favoriteCount = signal('0');

  get isLoading() {
    return this.#isLoading.asReadonly();
  }

  get favoriteCount() {
    return this.#favoriteCount.asReadonly();
  }

  addFavorite(roomDexId: string) {
    this.#isLoading.set(true);
    return this.#favoriteService.addFavorite(roomDexId).pipe(
      tap(() =>
        this.#favoriteCount.set(
          (parseInt(this.#favoriteCount()) + 1).toString()
        )
      ),
      finalize(() => this.#isLoading.set(false))
    );
  }

  removeFavorite(roomDexId: string) {
    this.#isLoading.set(true);
    return this.#favoriteService.removeFavorite(roomDexId).pipe(
      tap(() =>
        this.#favoriteCount.set(
          (parseInt(this.#favoriteCount()) - 1).toString()
        )
      ),
      finalize(() => this.#isLoading.set(false))
    );
  }

  initializeCount() {
    return this.#favoriteService.listFavorites().pipe(
      tap(favorites => {
        this.#favoriteCount.set(favorites.length.toString());
      })
    );
  }
}
